"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignResponseToJSON = exports.CampaignResponseFromJSONTyped = exports.CampaignResponseFromJSON = exports.instanceOfCampaignResponse = void 0;
var runtime_1 = require("../runtime");
var CampaignAdProduct_1 = require("./CampaignAdProduct");
var CampaignChannel_1 = require("./CampaignChannel");
var CampaignDerivedStatus_1 = require("./CampaignDerivedStatus");
var CampaignStatus_1 = require("./CampaignStatus");
var DeliveryGoalGroup_1 = require("./DeliveryGoalGroup");
var MeasurementPartners_1 = require("./MeasurementPartners");
var OptimizationPrefs_1 = require("./OptimizationPrefs");
/**
 * Check if a given object implements the CampaignResponse interface.
 */
function instanceOfCampaignResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCampaignResponse = instanceOfCampaignResponse;
function CampaignResponseFromJSON(json) {
    return CampaignResponseFromJSONTyped(json, false);
}
exports.CampaignResponseFromJSON = CampaignResponseFromJSON;
function CampaignResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'createdAt': !(0, runtime_1.exists)(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'updatedAt': !(0, runtime_1.exists)(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
        'purchaseOrder': !(0, runtime_1.exists)(json, 'purchase_order') ? undefined : json['purchase_order'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : (0, CampaignStatus_1.CampaignStatusFromJSON)(json['status']),
        'objective': !(0, runtime_1.exists)(json, 'objective') ? undefined : (0, OptimizationPrefs_1.OptimizationPrefsFromJSON)(json['objective']),
        'channel': !(0, runtime_1.exists)(json, 'channel') ? undefined : (0, CampaignChannel_1.CampaignChannelFromJSON)(json['channel']),
        'adProduct': !(0, runtime_1.exists)(json, 'ad_product') ? undefined : (0, CampaignAdProduct_1.CampaignAdProductFromJSON)(json['ad_product']),
        'spaaPixelId': !(0, runtime_1.exists)(json, 'spaa_pixel_id') ? undefined : json['spaa_pixel_id'],
        'measurementPartner': !(0, runtime_1.exists)(json, 'measurement_partner') ? undefined : (0, MeasurementPartners_1.MeasurementPartnersFromJSON)(json['measurement_partner']),
        'salesforceOpportunity': !(0, runtime_1.exists)(json, 'salesforce_opportunity') ? undefined : json['salesforce_opportunity'],
        'salesforceSalesOrder': !(0, runtime_1.exists)(json, 'salesforce_sales_order') ? undefined : json['salesforce_sales_order'],
        'derivedStatus': !(0, runtime_1.exists)(json, 'derived_status') ? undefined : (0, CampaignDerivedStatus_1.CampaignDerivedStatusFromJSON)(json['derived_status']),
        'deliveryGoalGroup': !(0, runtime_1.exists)(json, 'delivery_goal_group') ? undefined : (0, DeliveryGoalGroup_1.DeliveryGoalGroupFromJSON)(json['delivery_goal_group']),
        'adAccountId': !(0, runtime_1.exists)(json, 'ad_account_id') ? undefined : json['ad_account_id'],
    };
}
exports.CampaignResponseFromJSONTyped = CampaignResponseFromJSONTyped;
function CampaignResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updated_at': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'purchase_order': value.purchaseOrder,
        'status': (0, CampaignStatus_1.CampaignStatusToJSON)(value.status),
        'objective': (0, OptimizationPrefs_1.OptimizationPrefsToJSON)(value.objective),
        'channel': (0, CampaignChannel_1.CampaignChannelToJSON)(value.channel),
        'ad_product': (0, CampaignAdProduct_1.CampaignAdProductToJSON)(value.adProduct),
        'spaa_pixel_id': value.spaaPixelId,
        'measurement_partner': (0, MeasurementPartners_1.MeasurementPartnersToJSON)(value.measurementPartner),
        'salesforce_opportunity': value.salesforceOpportunity,
        'salesforce_sales_order': value.salesforceSalesOrder,
        'derived_status': (0, CampaignDerivedStatus_1.CampaignDerivedStatusToJSON)(value.derivedStatus),
        'delivery_goal_group': (0, DeliveryGoalGroup_1.DeliveryGoalGroupToJSON)(value.deliveryGoalGroup),
        'ad_account_id': value.adAccountId,
    };
}
exports.CampaignResponseToJSON = CampaignResponseToJSON;
